module.exports = __webpack_public_path__ + "static/media/subICloud1.31128dd2.png";